import { headerBgGradientAngle } from './HeaderBgStore';

export const updateHeaderBgGradientAngle = (value) => headerBgGradientAngle.update(oldValue => value);
